import { render, staticRenderFns } from "./BuildingDetailsView.vue?vue&type=template&id=fecadc2e&scoped=true"
import script from "./BuildingDetailsView.vue?vue&type=script&lang=js"
export * from "./BuildingDetailsView.vue?vue&type=script&lang=js"
import style0 from "./BuildingDetailsView.vue?vue&type=style&index=0&id=fecadc2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fecadc2e",
  null
  
)

export default component.exports